export const DIETARY_STYLES = [
  "Vegetarian", "Non-Vegetarian", "Eggetarian", "Vegan", "Diabetic-friendly", "Jain Food", "Gluten-Free", "Pescatarian",
];

export const HEALTH_CONDITIONS = [
  "One Kidney (Renal)", "Kidney Disease (CKD)", "High Uric Acid", "High Blood Pressure", "Low Blood Pressure",
  "High Creatinine", "High Sugar / Diabetes", "Cancer", "Thyroid", "PCOS", "Fatty Liver",
  "Gluten Allergy", "Nut Allergy", "Soy Allergy", "Lactose Intolerance", "Other Food Allergy",
];

export const ChipSelect = ({ options, value, onChange, testPrefix }) => (
  <div className="flex flex-wrap gap-1.5">
    {options.map((o) => {
      const on = value.includes(o);
      return (
        <button key={o} type="button" aria-pressed={on}
          data-testid={`${testPrefix}-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          onClick={() => onChange(on ? value.filter((v) => v !== o) : [...value, o])}
          className={`rounded-full border px-3 py-1.5 text-[11px] font-medium transition-all ${on ? "border-[#2D372B] bg-[#2D372B] text-white" : "border-[#E5E2D9] bg-white text-[#5C665A] hover:border-[#89937C]"}`}>
          {o}
        </button>
      );
    })}
  </div>
);
